import type { AppLang } from '../context/DirectionContext';

// Formatters are singletons — instantiated once, reused every call.
const FMT: Record<AppLang, Intl.DateTimeFormat> = {
  he: new Intl.DateTimeFormat('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric' }),
  en: new Intl.DateTimeFormat('en-GB',  { day: '2-digit', month: 'short',  year: 'numeric' }),
};

/**
 * Format a Date or ISO-8601 string for human-readable display.
 *
 * ONLY pass values you explicitly constructed as dates (e.g. candidate.lastStatusChangeAt).
 * Never wrap raw API strings — if Intl can't parse the input it is returned verbatim.
 */
export function formatDisplayDate(
  input: Date | string | null | undefined,
  lang: AppLang,
): string {
  if (input == null) return '';
  const d = input instanceof Date ? input : new Date(input as string);
  if (isNaN(d.getTime())) return String(input);
  return FMT[lang].format(d);
}
